"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _getScrollbarSize = _interopRequireDefault(require("@mui/utils/getScrollbarSize"));
var _default = exports.default = _getScrollbarSize.default;
